import { useQuery } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { BaseError } from "core/utils/baseError";

export const quickSightQueryKey = "quickSightDashboard";

/**
 * Hook for getting the quicksight dashboard for the given account number
 *
 * @param {string} account_number
 * @returns {useQuery<string, BaseError>}
 */
const useGetQuicksightDashboard = (
  account_number: string,
  queryKey?: (string | number)[],
) => {
  const clients = useClientContext();
  return useQuery<string, BaseError>({
    queryKey: queryKey ?? [quickSightQueryKey, account_number],
    queryFn: async () =>
      clients.management
        .getQuickSightDashboard({ account_number })
        .then((result) => result.embed_url),
  });
};

export default useGetQuicksightDashboard;
